import P2Regular from 'components/typography/P2Regular';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * A column for displaying remote source information in the revision table.
 */
export default function RemoteSourceColumn({ data }: { data: RevisionRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {data.remoteSource?.name ?? null}
    </P2Regular>
  );
}
